import { ButtonVariant, CoButton } from "components/CoButton";
import Popover from "components/Popover";
import { useBookmarks } from "features/Bookmarks";
import { IBookmarkItem } from "helpers/bookmark";
import useLabels from "hooks/useLabels";

type ThreadBookmarkActionsProps = {
  bookmark: IBookmarkItem;
};

function ThreadBookmarkActions({ bookmark }: ThreadBookmarkActionsProps) {
  const onDelete = () => {
    // TODO(Jimmy): Hook up the ability to delete a thread
  };

  const { deleteBookmarkItem } = useBookmarks();

  const onUnbookmark = () => {
    deleteBookmarkItem(bookmark);
  };

  return (
    <div>
      <Popover
        interactive
        tooltipContent={<ThreadBookmarkActionsPopover onDelete={onDelete} />}
        trigger="click"
      >
        <CoButton size="sm" variant={ButtonVariant.Flat} icon="icon-ellipsis" />
      </Popover>
      <CoButton
        variant={ButtonVariant.Flat}
        size="sm"
        className="px-2 md:px-4"
        onClick={onUnbookmark}
        icon="icon-bookmark-solid"
      />
    </div>
  );
}

export default ThreadBookmarkActions;

type ThreadBookmarkActionsMenuProps = {
  onDelete: () => void;
};

function ThreadBookmarkActionsPopover({
  onDelete,
}: ThreadBookmarkActionsMenuProps) {
  const [labels] = useLabels("features.bookmark-lists.bookmark-list-detail");

  return (
    <div className="flex flex-col w-40">
      <button
        onClick={onDelete}
        disabled
        className="flex items-center w-full gap-3 text-alert-fg-base"
      >
        <i className="text-xl icon-trash-2 text-alert-fg-base" />
        <span>{labels["delete-thread"]}</span>
      </button>
    </div>
  );
}
